module.exports = __webpack_public_path__ + "static/img/cct-ss.a92339c4.png";